import { IQuestionOption, QuestionOption } from './question-option.model';
import { IExamFile, ExamFile } from './exam-file.model';

export interface ISavedAnswer {
  idQuestion: string;
  idQuestionOptions: string[];
  numericValue?: number | null;
}

export interface IExamQuestion {
  idQuestion: string;
  idExam: string;
  statement: string;
  questionType: string;
  order: number;
  options: IQuestionOption[];
  savedAnswer: ISavedAnswer | null;
  files: IExamFile[];
}

export class ExamQuestion {
  idQuestion: string;
  idExam: string;
  statement: string;
  questionType: string;
  order: number;
  options: QuestionOption[];
  savedAnswer: ISavedAnswer | null;
  files: ExamFile[];

  constructor(data: IExamQuestion) {
    this.idQuestion = data.idQuestion;
    this.idExam = data.idExam;
    this.statement = data.statement;
    this.questionType = data.questionType;
    this.order = data.order;
    this.options = data.options.map(o => new QuestionOption(o));
    this.savedAnswer = data.savedAnswer;
    this.files = (data.files ?? []).map(f => new ExamFile(f));
  }
}
